import { Link } from "react-router-dom";
import Button from "../../components/Button";
import PromoCode from "../../components/PromoCode";
import CheckoutProductItem from "./CheckoutProductItem";

const CheckoutSummary = () => {
  return (
    <div className="px-4">
      <div className="mx-4">
        <div className="title mb-4 text-lg font-medium">
          <h4>Summary</h4>
          <span className="text-sm text-[#8b8b8b] font-normal">2 Items</span>
        </div>
        <div className="checkout-items border-b">
          <ul>
            <li>
              {Array(2)
                .fill(true)
                .map((item, index) => {
                  return <CheckoutProductItem />;
                })}
            </li>
          </ul>
        </div>
        <div className="summary-details text-base mb-4 py-4">
          <ul>
            <li className="flex items-center justify-between">
              <span>Subtotal</span>
              <span>₺5.99</span>
            </li>
            <li className="flex items-center justify-between">
              <span>Shipping</span>
              <span>Free</span>
            </li>
            <li className="total flex justify-between border-y my-4 py-4">
              <div className="flex flex-col">
                <span>Total</span>
                <span className="text-sm text-[#8b8b8b]">(including VAT)</span>
              </div>
              <div>
                <span className="font-medium">₺1500.00</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="actions px-4">
        <div className="promo-code">
          <PromoCode />
        </div>
        <div className="my-4">
          <Link to="/everyone/shop/payment">
            <Button width={"w-full"}>Save and Continue</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSummary;
